export const GET_VENUES= 'GET_VENUES'
export const GET_VENUES_SUCCESS= 'GET_VENUES_SUCCESS'
export const GET_VENUES_ERROR='GET_VENUES_ERROR'

export const GetVenues= (data) => ({
    type: GET_VENUES,
    payload: data
})


